<template>
  <button @click="exportData" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportData: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/lookup-call', {
          params: params
        });
        params.page += 1;
        response = result.data;
        for (let item of response.docs) {
          let row = {
            companyName: item.client ? item.client.companyName : '',
            phone: item.client ? item.client.phone : '',
            email: item.client ? item.client.email : '',
            domain: item.client ? item.client.domain : '',
            fromNumber: item.fromNumber,
            toNumber: item.toNumber,
            network: item.network ? item.network.name : '',
            gateway: item.gateway ? item.gateway.name : '',
            direction: this.$t(item.direction),
            startTime: item.startTime ? moment(item.startTime).format('DD/MM/YYYY HH:mm:ss') : '',
            answerTime: item.answerTime ? moment(item.answerTime).format('DD/MM/YYYY HH:mm:ss') : '',
            endTime: item.endTime ? moment(item.endTime).format('DD/MM/YYYY HH:mm:ss') : '',
            billDuration: this.callDuration(item.billDuration),
            recordingUrl: await this.getRecordingUrl(item),
            user: this.getUser(item),
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        }
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'call-lookup.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('companyName'), key: 'companyName', width: 15},
        {header: this.$t('phone'), key: 'phone', width: 15},
        {header: 'Email client', key: 'email', width: 15},
        {header: 'Domain', key: 'domain', width: 15},
        {header: this.$t('fromNumber'), key: 'fromNumber', width: 15},
        {header: this.$t('toNumber'), key: 'toNumber', width: 15},
        {header: this.$t('network'), key: 'network', width: 15},
        {header: this.$t('gateway'), key: 'gateway', width: 15},
        {header: this.$t('direction'), key: 'direction', width: 15},
        {header: this.$t('startTime'), key: 'startTime', width: 15},
        {header: this.$t('answerTime'), key: 'answerTime', width: 15},
        {header: this.$t('endTime'), key: 'endTime', width: 15},
        {header: this.$t('billDuration'), key: 'billDuration', width: 15},
        {header: this.$t('recordingUrl'), key: 'recordingUrl', width: 15},
        {header: this.$t('user'), key: 'user', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    },
    getUser(item) {
      if (item.direction === 'inbound' && item.toUser && item.toUser.name) {
        return item.toUser.name + ` (${item.toUser.ext})`;
      } else if (item.direction === 'outbound' && item.fromUser && item.fromUser.name) {
        return item.fromUser.name + ` (${item.fromUser.ext})`;
      } else {
        return ''
      }
    },
    callDuration(value) {
      value = Math.round(value);
      let sec = value % 60;
      let min = parseInt(value / 60);
      if (sec < 10) {
        sec = `0${sec}`;
      }
      if (min < 10) {
        min = `0${min}`;
      }
      return `${min}:${sec}`;
    },
    async getRecordingUrl(item) {
      let url = ''
      if (item.recordingDownloaded) {
        let response = await this.$service.get(`/call/${item._id}/recording`)
        if (response.data && response.data.url) {
          url = response.data.url
        }
      }
      return url
    }
  },
  i18n: {
    messages: {
      en: {
        phone: 'Phone number',
        user: 'Agent',
        startTime: 'Start time',
        answerTime: 'Answer time',
        endTime: 'End time',
        billDuration: 'Bill duration',
        fromNumber: 'From number',
        toNumber: 'To number',
        gateway: 'Gateway',
        direction: "Calling direction",
        recordingUrl: "Link to recording file",
      },
      vi: {
        phone: 'SĐT client',
        user: 'Nhân viên',
        startTime: 'Gọi lúc',
        answerTime: 'Trả lời',
        endTime: 'Kết thúc',
        billDuration: 'Thời gian đàm thoại',
        fromNumber: 'Gọi từ SĐT',
        toNumber: 'Gọi tới SĐT',
        gateway: 'Gateway',
        direction: "Hướng gọi",
        recordingUrl: "Link file ghi âm",
      }
    }
  }
}
</script>